<div class="row">
    <div class="col-md-12">
        <nb-card>
                    <nb-card-header>
                        <div class="row text-center align-items-center">
                            <div class="col-md-4 d-flex align-items-center gap-2">
                                <div class="d-inline-flex align-items-center gap-2" data-tour="navigation">
                                    <div class="btn-group">
                                        <div class="btn btn-outline-secondary" mwlCalendarPreviousView [view]="view"
                                            [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
                                            Précédent
                                        </div>
                                        <div class="btn btn-outline-secondary" mwlCalendarNextView [view]="view"
                                            [(viewDate)]="viewDate" (viewDateChange)="onViewDateChange()">
                                            Suivant
                                        </div>
                                    </div>
                                    <div class="btn btn-outline-deebr" mwlCalendarToday [(viewDate)]="viewDate"
                                        (viewDateChange)="onViewDateChange()">
                                        Aujourd'hui
                                    </div>
                                    <button class="btn btn-outline-secondary btn-calendar-picker"
                                        [nbPopover]="calendarPopover" nbPopoverPlacement="bottom"
                                        nbPopoverTrigger="click">
                                        <i class="bi bi-calendar3"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle') }}</h3>
                            </div>
                            <div class="col-md-4 text-end" data-tour="actions">
                                <button nbButton status="primary"
                                    [disabled]="selectedCampaignIds.size < 2"
                                    (click)="openOptimizeDialog()" data-tour="optimize-btn">
                                    Optimiser{{ selectedCampaignIds.size > 1 ? ' (' + selectedCampaignIds.size + ')' : '' }}
                                </button>
                                <button nbButton outline status="danger" class="ms-2"
                                    [disabled]="selectedCampaignIds.size === 0 || isDeleting"
                                    [nbSpinner]="isDeleting" nbSpinnerStatus="danger"
                                    (click)="deleteSelected()" data-tour="delete-btn">
                                    Supprimer{{ selectedCampaignIds.size > 0 ? ' (' + selectedCampaignIds.size + ')' : '' }}
                                </button>
                                <button nbButton status="danger" class="ms-2"
                                    [nbSpinner]="isDownloading" nbSpinnerStatus="control"
                                    [disabled]="isDownloading || selectedCampaignIds.size === 0"
                                    (click)="downloadSelected()" data-tour="export-btn">
                                    Exporter{{ selectedCampaignIds.size > 0 ? ' (' + selectedCampaignIds.size + ')' : '' }}
                                </button>
                                <div *ngIf="isDownloading" class="text-muted small mt-1">
                                    Segments en cours de création, cela peut prendre plusieurs minutes
                                </div>
                                <button nbButton ghost size="small" class="ms-2 tour-help-btn"
                                    (click)="startTour()" title="Aide">
                                    <i class="bi bi-question-circle"></i>
                                </button>
                            </div>
                        </div>
                    </nb-card-header>
                    <nb-card-body>
                        <!-- Custom Kanban Week View -->
                        <div class="kanban-view d-flex overflow-auto" data-tour="calendar" cdkDropListGroup>
                            <div class="kanban-column p-2 border-end" *ngFor="let day of weekDays"
                                style="flex: 1 1 0; min-width: 200px; overflow-x: hidden;">
                                <div class="text-center mb-3">
                                    <div class="fw-bold text-uppercase text-secondary small">{{ day | date:'EEE':'':'fr'
                                        }}</div>
                                    <div class="h4">{{ day | date:'d' }}</div>
                                </div>
                                <div class="kanban-events d-flex flex-column gap-2"
                                    cdkDropList
                                    [cdkDropListData]="day"
                                    (cdkDropListDropped)="onDrop($event)">
                                    <div class="kanban-card p-3 bg-light border rounded position-relative cursor-pointer shadow-sm"
                                        *ngFor="let event of getCampaignsForDay(day); trackBy: trackByEventId"
                                        cdkDrag
                                        [cdkDragData]="event"
                                        (cdkDragStarted)="onDragStarted()"
                                        (cdkDragEnded)="onDragEnded()"
                                        [style.border-left]="'5px solid ' + event.color?.primary"
                                        [class.kanban-card--hovered]="hoveredEventId === event.meta.id && hoveredLinkedIds.size > 0"
                                        [class.kanban-card--linked]="hoveredLinkedIds.has(event.meta.id)"
                                        [class.kanban-card--dimmed]="hoveredEventId !== null && hoveredEventId !== event.meta.id && !hoveredLinkedIds.has(event.meta.id) && hoveredLinkedIds.size > 0"
                                        (mouseenter)="onCardMouseEnter(event.meta.id)"
                                        (mouseleave)="onCardMouseLeave()"
                                        (click)="openSidebar(day, event)">

                                        <!-- Selection Checkbox Area -->
                                        <div class="selection-overlay"
                                            (click)="$event.stopPropagation(); toggleSelection(event.meta.id)">
                                            <nb-checkbox [checked]="selectedCampaignIds.has(event.meta.id)"
                                                status="primary" style="pointer-events: none;"></nb-checkbox>
                                        </div>

                                        <div class="fw-bold mb-1 pe-4" data-tour="campaign-card-title">
                                            {{ event.title }}
                                            <span *ngIf="event.meta?.segments?.capping?.capped_with?.length && event.meta?.segments?.capping?.stale"
                                                class="badge-stale ms-1"
                                                nbTooltip="Réoptimiser les campagnes"
                                                nbTooltipStatus="warning">⚠️</span>
                                        </div>

                                        <!-- Categories as badges -->
                                        <div class="d-flex flex-wrap gap-1 mb-2"
                                            *ngIf="event.meta?.stats?.categoryList?.length">
                                            <span *ngFor="let cat of event.meta.stats.categoryList"
                                                class="kanban-cat-badge"
                                                [ngClass]="cat.metaIndex < 5 ? 'meta-color-' + cat.metaIndex : 'meta-color-default'">{{ cat.label }}</span>
                                        </div>

                                        <!-- Stats Row -->
                                        <div class="d-flex justify-content-between align-items-center small text-muted"
                                            *ngIf="event.meta?.stats">
                                            <div title="Nombre d'utilisateurs">
                                                <i class="bi bi-people me-1"></i>
                                                <span>{{ event.meta.stats.userCount | number }}</span>
                                            </div>
                                            <div title="Lift">
                                                <i class="bi bi-graph-up-arrow me-1"></i>
                                                <span>{{ event.meta.stats.lift }}x</span>
                                            </div>
                                            <div title="Potentiel">
                                                <i class="bi bi-pie-chart me-1"></i>
                                                <span>{{ event.meta.stats.potential }}%</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- Create Placeholder (outside cdkDropList) -->
                                <div class="create-card-placeholder p-4 border border-2 border-dashed rounded text-center text-muted cursor-pointer hover-bg-light"
                                    data-tour="create-card"
                                    (click)="openSidebar(day)">
                                    <i class="bi bi-plus-lg h2 mb-2"></i>
                                    <span class="small fw-bold">Créer une campagne</span>
                                </div>
                            </div>
                        </div>
                    </nb-card-body>
                </nb-card>
            </div>
        </div>

<!-- Sidebar for Editing -->
<div class="sidebar-pannel" [class.open]="sidebarOpen">
    <div class="sidebar-content">
        <div class="sidebar-body">
            <app-campaign-sidebar *ngIf="sidebarOpen" [date]="selectedDate" [campaignInput]="selectedCampaign"
                (saved)="onCampaignSaved($event)" (closed)="closeSidebar()"></app-campaign-sidebar>
        </div>
    </div>
</div>

<div class="sidebar-backdrop" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>

<ng-template #unsavedChangesDialog let-ref="dialogRef">
    <nb-card>
        <nb-card-header>Modifications non enregistrées</nb-card-header>
        <nb-card-body>Des modifications non enregistrées seront perdues. Continuer ?</nb-card-body>
        <nb-card-footer>
            <div class="row">
                <div class="col text-center">
                    <button nbButton status="success" (click)="ref.close(true)">Oui, quitter</button>
                </div>
                <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close(false)">Non, annuler</button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>

<ng-template #deleteConfirmDialog let-ref="dialogRef">
    <nb-card>
        <nb-card-header>Supprimer les campagnes</nb-card-header>
        <nb-card-body>Supprimer {{ selectedCampaignIds.size }} campagne(s) ? Cette action est irréversible.</nb-card-body>
        <nb-card-footer>
            <div class="row">
                <div class="col text-center">
                    <button nbButton status="danger" (click)="ref.close(true)">Oui, supprimer</button>
                </div>
                <div class="col text-center">
                    <button nbButton status="basic" (click)="ref.close(false)">Annuler</button>
                </div>
            </div>
        </nb-card-footer>
    </nb-card>
</ng-template>

<ng-template #calendarPopover>
    <nb-calendar [(date)]="viewDate" (dateChange)="onCalendarDatePick($event)"></nb-calendar>
</ng-template>